import "@ant-design/v5-patch-for-react-19"
import _AppPage from "@agenta/oss/src/pages/_app"

export default _AppPage
